<template>

<fragment>

<div class="mobile" :class="{'has-scrolled': scrollY > 24}">

    <core-avatar type="context" class="mobile-context" v-on:click="onContextClick" />

    <div class="mobile-title" :style="{marginTop: marginTop}">{{ title }}<small v-if="$route.meta.mobilesubtitle">{{ $route.meta.mobilesubtitle }}</small></div>

</div>

</fragment>

</template>

<script>

export default {

    data: function() {

        return {
            scrollY: 0
        }

    },

    created: function() {

        this.$pubsub.$on('content.scroll', this.onContentScroll.bind(this))

    },

    beforeDestroy: function() {

        this.$pubsub.$off('content.scroll', this.onContentScroll.bind(this))

    },

    computed: {

        title: function() {

            return (this.$_.isFunction(this.$route.meta.mobiletitle)) ? this.$route.meta.mobiletitle.call(this) : this.$route.meta.mobiletitle

        },

        marginTop: function() {

            return (0 - this.scrollY).toString() + 'px'

        }

    },

    methods: {

        onContentScroll: function(y) {

            this.scrollY = y

        },

        onContextClick: function() {

            this.$emit('context')

        }

    }

}

</script>

<style scoped>

.mobile {
    width: calc(100% - 20px);
    z-index: 100000001;
    position: fixed;
    left: 10px;
    height: 50px;
}

.is-listing .mobile {
    background-color: #fff;
}

.mobile-context {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    top: 8px;
    left: 0px;
    position: absolute;
    z-index: 2;
}

#app:not(.is-listing) .mobile.has-scrolled .mobile-context {
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}

.mobile-title {
    position: absolute;
    left: 0px;
    color: #343434;
    top: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-family: 'Barlow', sans-serif;
    width: 100%;
    height: 50px;
    font-size: 16px;
    letter-spacing: 1px;
    font-weight: 700;
}

.is-listing .mobile-title {
    margin-top: 0px!important;
}

.mobile-title small {
    font-size: 12px;
    font-weight: 400;
    opacity: 0.6;
}

</style>
